// extracted by mini-css-extract-plugin
export default {"Container":"card_Container__hFZK8","Card":"card_Card__blOgC","Card__content__title":"card_Card__content__title__va1hM","Card__content__text":"card_Card__content__text__txUan"};